import { Badge } from "react-bootstrap";

const StatusFormat = ({ value }) => {
  const statuses = {
    "Pending Approval": "secondary",
    Review: "warning",
    Approved: "primary",
    Declined: "danger",
    Canceled: "danger",
    Draft: "warning",
    "Partially Processed": "info",
    Processed: "success",
    "Partially Received": "info",
    Received: "success",
    "Partially Released": "info",
    Released: "success",
    Disposed: "danger",
    Outbox: "dark",
  };
  return <Badge bg={statuses[value]}>{value}</Badge>;
};

export default StatusFormat;
